import React from 'react';

import {Close as CloseIcon} from '@mui/icons-material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import {Box, ButtonBase, Dialog, DialogContent, DialogTitle, Typography, useMediaQuery, useTheme} from '@mui/material';
import Slide from '@mui/material/Slide';

import {Text} from 'components';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const styles = {
    root: {
        '.MuiDialog-container': {
            alignItems: 'baseline',
        },
        margin: 0,
        width: '100%',
    },
    menuHeader: {
        color: 'white.main',
        height: '70px',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: 'black.dark',
        paddingX: 2,
    },
    menuHeaderButton: {
        color: 'grey.mainlight',
        fontSize: '16px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: 0,
        margin: 0,
        minWidth: 'auto',
        width: 'auto',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        flexShrink: 0,
        paddingRight: 2,
    },
    menuHeaderButtonNoPadding: {
        paddingRight: 0,
    },
    menuHeaderText: {
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        height: '70px',
        color: 'white.main',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        fontWeight: '500',
    },
    content: {
        padding: 0,
        backgroundColor: 'grey.darkest',
        borderTop: 'none'
    },
    contentDevider: {
        width: '100%',
        height: '1px',
        paddingX: 4,
        boxSizing: 'border-box',
    },
};

const BaseDialog = ({open, handleBack, handleClose, title, children, Icon, pt= 20, dividers = false, fullscreen, ...rest}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

    const sx = styles.root;
    if (pt !== undefined) {
        sx['& .MuiDialog-container'] = {pt};
    }

    if (fullscreen === undefined) {
        fullscreen = isMobile;
    }

    return <Dialog
        TransitionComponent={Transition} fullScreen={fullscreen} open={open} onClose={handleClose} fullWidth={true} sx={sx} {...rest}>
        {title && <DialogTitle sx={styles.menuHeader} direction="row" alignItems="center">
            {handleBack &&
                <ButtonBase sx={styles.menuHeaderButton} onClick={handleBack} disableRipple data-testid="dialog-back-btn">
                    <KeyboardBackspaceIcon/>
                </ButtonBase>
            }
            <Typography sx={styles.menuHeaderText}><Text>{title}</Text></Typography>
            {handleClose &&
                <ButtonBase sx={[styles.menuHeaderButton, styles.menuHeaderButtonNoPadding]} onClick={handleClose} disableRipple data-testid="dialog-close-btn">
                    {Icon || <CloseIcon />}
                </ButtonBase>
            }
        </DialogTitle>
        }

        <DialogContent sx={styles.content} dividers={dividers}>
            <Box sx={styles.contentDevider}></Box>
            {children}
        </DialogContent>
    </Dialog>;
};

export default BaseDialog;
